export default __webpack_public_path__ + "static/media/Profile.e4b45581.png";